

























import { CreateElement, VNode } from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SwTable, TableColumnConfig, TableEntry } from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import RegexValidators from '@/shared/regex-validators';

const cssPrefix = 'manage-alternateemail-step2';
@Component({
  components: {
    SwButton,
    SwTextfield,
    SwTable,
  },
})
export default class ManageAlternateemailStep2 extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @Prop({ required: true })
  tableData: any;

  @Watch('tableData', { immediate: true })
  handleTableData(data: any) {
    this.basicData = [...data] || {};
  }

  basicData: any[] = [];
  selectedBasicTableDataRows: any[] = [];
  emailValidator = new RegExp(RegexValidators.email);

  get basicTableData() {
    return this.basicData?.map((ele: any, index: any) => {
      return { ...ele, _key: index };
    });
  }

  get basicColumnsConfig(): TableColumnConfig[] {
    return [
      {
        key: 'index',
        type: 'index',
      },
      {
        key: 'name',
        dataKey: 'name',
        title: this.$t('products.name').toString(),
      },
      {
        key: 'serialNumber',
        dataKey: 'serialNumber',
        title: this.$t('products.serialnumber').toString(),
      },
      {
        key: 'emailAddress',
        dataKey: 'emailAddress',
        title: this.$t('altenateEmail.addAlternateEmail').toString(),
        sorter: true,
        render: (h: CreateElement, data: { entry: TableEntry }): VNode =>
          this.emailAddressColumnRenderer(h, data),
      },
    ];
  }

  // tslint:disable-next-line
  emailAddressColumnRenderer(h: CreateElement, data: { entry: TableEntry }) {
    return (
      <div class="friendlyname_col">
        <SwTextfield
          name={data.entry.emailAddress}
          props-value={data.entry.emailAddress}
          on-input={(e: any) => {
            data.entry.emailAddress = e;
          }}
        ></SwTextfield>
      </div>
    ) as VNode;
  }

  saveChanges() {
    const atpemaillist: any[] = [];
    this.basicTableData.forEach((ele: any) => {
      if (ele.emailAddress !== '--' && ele.emailAddress !== '') {
        atpemaillist.push({ serialNumber: ele.serialNumber, emailAddress: ele.emailAddress });
      }
    });
    const template = {
      atpEmail: atpemaillist,
    };
    const allEmail: any[] = [];
    atpemaillist.forEach(each => allEmail.push(...each.emailAddress.split(',')));
    if (this.validateEmails(allEmail)) {
      this.$store.commit('startLoading');
      this.$store
        .dispatch('SnbProfileStoreModule/updateAlternateEmail', template)
        .then((resp) => {
          this.$store.commit('stopLoading');
          if (resp?.operationStatus === 'OK') {
            this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp?.msgDesc });
            this.$emit('closeModal');
          } else {
            this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp?.msgDesc });
          }
        });
    } else {
      this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: 'Email Address(es) is(are) not in the correct format' });
    }
  }

  validateEmails(emails: any) {
    let flag = true;
    emails.forEach((ele: any) => {
      if (!ele.match(this.emailValidator)) {
        flag = false;
      }
    });
    return flag;
  }
}
